<template>
  <iframe
    class="kpb-embed"
    :src="data.src"
    :style="`--kpb-embed-aspect-ratio: ${aspectRatio}; --kpb-embed-background-color: ${backgroundColor}`"
    frameborder="0"
    allowfullscreen
  ></iframe>
</template>

<script>
/** Component for embedding other webpages */
export default {
  props: {
    data: Object,
    aspectRatio: {
      type: [Number, String],
      default: 16 / 9,
    },
    backgroundColor: {
      type: String,
      default: '#fafafa',
    },
  },
}
</script>

<style lang="scss">
.kpb-embed {
  width: 100%;
  aspect-ratio: var(--kpb-embed-aspect-ratio);
  background-color: var(--kpb-embed-background-color);
}
</style>
